import { AgentConfig } from '@/components/Agents/AgentConfig/AgentConfig';
import { LocalCapabilityType } from '@/components/AiWorkflow/formSchema';
import { useGoogleDriveActions } from '@/store/googleDriveStore';

import CapabilitiesTitle from './CapabilitiesTitle';
import LegacyAgentRow from './LegacyAgentRow';
import MyCapabilitiesRow from './MyCapabilitiesRow';
import {
  HeaderRow,
  Container,
  TableBody,
  HeaderCell,
  TableHeader,
  StickyContainer,
  AgentConfigContainer,
  BorderWrapper
} from './MyCapabilitiesStyles';
import { useMyCapabilities } from './hooks/useMyCapabilities';
import { useNativeAgents } from './hooks/useNativeAgents';

const MyCapabilities = ({
  setEditWorkflow,
  setIsWorkflowOpen
}: {
  setEditWorkflow: (workflow: LocalCapabilityType) => void;
  setIsWorkflowOpen: (isOpen: boolean) => void;
}) => {
  const { myAgents, handleToggle } = useMyCapabilities();
  const { setSelectedGoogleDriveFiles } = useGoogleDriveActions();

  const handleEditWorkflow = (workflow: LocalCapabilityType) => {
    setSelectedGoogleDriveFiles(workflow.googleDrive?.files ?? []);
    setEditWorkflow(workflow);
    setIsWorkflowOpen(true);
  };

  const {
    selectedNativeAgent,
    setSelectedNativeAgent,
    smartTemplateAgent,
    taskFollowUpAgent,
    toggleUserAgentsConfig
  } = useNativeAgents();

  return (
    <Container>
      {selectedNativeAgent && (
        <AgentConfigContainer
          sx={{
            paddingLeft: { xs: '1vw', md: '1vw', lg: '3vw' },
            paddingTop: { xs: '1vw', md: '1vw', lg: '4vw' }
          }}
        >
          <AgentConfig
            onBack={() => setSelectedNativeAgent(null)}
            selectedAgent={selectedNativeAgent}
          />
        </AgentConfigContainer>
      )}
      <CapabilitiesTitle title="My Capabilities" />
      <BorderWrapper>
        <StickyContainer>
          <TableHeader>
            <HeaderRow>
              <HeaderCell>Agent name & task</HeaderCell>
              <HeaderCell>Trigger</HeaderCell>
              <HeaderCell>Status</HeaderCell>
              <HeaderCell>Last edited</HeaderCell>
              <HeaderCell>Actions</HeaderCell>
            </HeaderRow>
          </TableHeader>
        </StickyContainer>
        <TableBody>
          <LegacyAgentRow
            key={smartTemplateAgent.id}
            {...smartTemplateAgent}
            setSelectedNativeAgent={setSelectedNativeAgent}
            handleToggle={toggleUserAgentsConfig}
          />
          <LegacyAgentRow
            key={taskFollowUpAgent.id}
            {...taskFollowUpAgent}
            setSelectedNativeAgent={setSelectedNativeAgent}
            handleToggle={toggleUserAgentsConfig}
          />
          {myAgents?.map(row => (
            <MyCapabilitiesRow
              key={row.id ?? ''}
              {...row}
              handleToggle={handleToggle}
              handleEdit={handleEditWorkflow}
            />
          ))}
        </TableBody>
      </BorderWrapper>
    </Container>
  );
};

export default MyCapabilities;
